import type {GuidedMiddleware} from '../models/middleware';

const dropWhenTermProvided: GuidedMiddleware = async (params, next) => {
    const { guidedRequest } = params;
    if ((guidedRequest?.searchTerm?.length ?? 0) != 0) {
      return [];
    }
    return next(params);
};

export default dropWhenTermProvided;
